import { createEvent, createStore, sample } from 'effector';
import $$api from 'models/api';
import { hideModal } from 'models/modals';

import { Participant } from 'types/zod/participant';
import { ParticipantReferences } from 'types/zod/participant-references';

const removeParticipant = createEvent<Participant['participant_id']>();

sample({ clock: removeParticipant, target: $$api.participants.removeParticipantFx });

const $participantReferences = createStore<ParticipantReferences>({});

sample({
    source: $participantReferences,
    clock: $$api.participants.getParticipantReferencesFx.done,
    fn: (references, { result }) => ({ ...references, ...result }),
    target: $participantReferences,
});

sample({
    clock: $$api.participants.removeParticipantFx.done,
    fn: () => 'PARTICIPANT_WIDGET_EDIT_MODAL' as const,
    target: hideModal,
});

const $$participantWidget = {
    removeParticipant,

    $participantReferences,
};

export default $$participantWidget;
